// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audio-upload{position:relative;float:left;border:1px solid #c3c4be;width:99.25%;background:#fff;text-align:center;box-sizing:border-box}.audio-upload *{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
